module.exports = __webpack_public_path__ + "static/media/upi-qr-code.2d4da448.jpeg";